export interface ISQLSeedingTranslator {
  matchingFilenames: string[];
  commands: string[];
}

export interface IFileData {
  filePath: string;
  fileName: string;
}
